import React, { useEffect, useState } from "react";
import { message, Modal, Form, Input } from "antd";
import inputStyles from "../../../../styles/Custom/Input.module.css";
import { raiseDeleteServiceRequestApi } from "../../../../services/receptionist.services";
import styles from "./DeleteRequestModal.module.css";

const DeleteRequestModal = ({
  open,
  setOpen,
  editData,
  refresh,
  selectedRowKeys,
  setSelectedRowKeys,
}) => {
  const [reason, setReason] = useState(null);
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined"
      ? window.matchMedia("(max-width: 768px)").matches
      : false
  );

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    const fn = () => setIsMobile(mq.matches);
    fn();
    mq.addEventListener("change", fn);
    return () => mq.removeEventListener("change", fn);
  }, []);

  const onFinish = () => {
    if (editData) {
      raiseDeleteServiceRequestApi({
        id: editData,
        reason: reason,
      })
        .then((res) => {
          message.success(res?.data?.message);
          setOpen(false);
          refresh();
          setSelectedRowKeys([]);
        })
        .catch((err) => {
          message.error(err?.response?.data?.message);
        });
    } else {
      message.error("Please select a practitioner");
    }
  };

  return (
    <>
      <Modal
        title="Delete service request"
        open={open}
        onCancel={() => setOpen(false)}
        onOk={onFinish}
        centered={!isMobile}
        destroyOnClose
        width={isMobile ? 400 : undefined}
        wrapClassName={isMobile ? styles.deleteServiceModalWrap : undefined}
        styles={{
          body: isMobile ? { padding: 0 } : { paddingTop: 24 },
        }}
      >
        <Form
          layout="vertical"
          style={{ marginBottom: 0 }}
        >
          <Form.Item label="Reason" name="Reason">
            <Input.TextArea
              placeholder="Enter reason"
              className={inputStyles.mdInput}
              style={{ width: isMobile ? "100%" : "300px" }}
              onChange={(e) => setReason(e.target.value)}
              rows={isMobile ? 3 : 3}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default DeleteRequestModal;
